// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__gVb6o","dot":"index_dot__OAVsK","glow":"index_glow__UmYhr"};